import { profileState } from "@/atoms/user/profile-state";
import { ButtonColor } from "@/common/enum/button-color";
import { QuestionMarkOutlineIcon } from "@/components/icon/QuestionMarkOutline";
import { TextInputLabel } from "@/components/label/TextInputLabel";
import { Body14Medium } from "@/components/typography/Body14Medium";
import { Button, Label, Modal, Radio, TextInput } from "flowbite-react";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { H4 } from "@/components/typography/H4";
import { Body16Regular } from "@/components/typography/Body16Regular";

export interface ReceiptState {
  isApplied: boolean;
  type: "business" | "personal";
  taxNumber: string;
}

const VirtualAccountInput = ({
  receiptState,
  setReceiptState,
}: {
  receiptState: ReceiptState;
  setReceiptState: React.Dispatch<React.SetStateAction<ReceiptState>>;
}) => {
  const [open, setOpen] = useState(false);

  const profile = useRecoilValue(profileState);

  useEffect(() => {
    if (profile) {
      setReceiptState((prev) => ({
        ...prev,
        taxNumber:
          prev.type === "business" ? profile.businessNumber : profile.phone,
      }));
    }
  }, [profile]);

  return (
    <div className="p-6 bg-[#f8f8f9] rounded-lg border border-[#1c375a]/20 space-y-5">
      <div className="space-y-3">
        <TextInputLabel required>
          <div className="flex items-center gap-2">
            현금영수증
            <div className="hover:cursor-pointer" onClick={() => setOpen(true)}>
              <QuestionMarkOutlineIcon />
            </div>
          </div>
        </TextInputLabel>
      </div>
      {receiptState.isApplied && (
        <>
          <div className="flex gap-6">
            <div className="flex items-center gap-2">
              <Radio
                id="business"
                name="receiptType"
                checked={receiptState.type === "business"}
                onChange={() =>
                  setReceiptState((prev) => ({
                    ...prev,
                    type: "business",
                    taxNumber: profile?.businessNumber || "",
                  }))
                }
              />
              <Label htmlFor="business">사업자 지출증빙</Label>
            </div>
            <div className="flex items-center gap-2">
              <Radio
                id="personal"
                name="receiptType"
                checked={receiptState.type === "personal"}
                onChange={() =>
                  setReceiptState((prev) => ({
                    ...prev,
                    type: "personal",
                    taxNumber: profile?.phone || "",
                  }))
                }
              />
              <Label htmlFor="personal">개인소득공제</Label>
            </div>
          </div>

          <div className="space-y-2">
            <div className="flex items-center gap-0.5">
              <TextInputLabel required>
                {receiptState.type === "business" ? "사업자 번호" : "전화번호"}
              </TextInputLabel>
            </div>
            <TextInput
              value={receiptState.taxNumber}
              onChange={(e) =>
                setReceiptState((prev) => ({
                  ...prev,
                  taxNumber: e.target.value,
                }))
              }
              placeholder={
                receiptState.type === "business"
                  ? "000-00-00000"
                  : "010-0000-0000"
              }
            />
          </div>
        </>
      )}

      <Modal show={open} onClose={() => setOpen(false)} size="md">
        <Modal.Header className="border-b border-[#1c375a]/20 flex items-center">
          <H4>현금영수증 안내</H4>
        </Modal.Header>
        <Modal.Body className="">
          <Body16Regular>
            <ul className="list-disc pl-5 break-keep whitespace-normal marker:text-xs">
              <li>
                현금영수증 발급 의무에 따라 가상계좌(무통장입금), 계좌이체 등 현금으로 구매시  구매금액으로
                현금영수증이 자동 발급 됩니다. 
              </li>
              <br />
              <li>
                현금영수증 확인 및 정보 변경을 원하실 경우, 국세청 홈페이지에서
                확인하실 수 있습니다. 
              </li>
              <br />
              <li>
                현금영수증(지출증빙용)은 법인세법 116조 2항 및 부가가치세법 32조
                2의 3항에 의해 세금계산서와 동일한 자격 및 효력이 있습니다. 
              </li>
              <br />
              <li>
                현금영수증에 대한 자세한 내용은 국세청홈텍스
                홈페이지(http://www.hometax.go.kr)을 참고하여 주시기 바랍니다.
              </li>
              <br />
              <li>
                발급된 현금영수증은 국세청 현금영수증 홈페이지에서
                확인하실 수 있습니다. (현금영수증 홈페이지:
                https://www.hometax.go.kr)
              </li>
            </ul>
          </Body16Regular>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VirtualAccountInput;
